import axios from '@/api/axios'
let api = {}
/**
 * 登录
 * @param {string} obj 
 * @returns 
 */

// 订单详情
api.order_detail = (param) => axios.post(`api/v1.order/order_detail`, param)


// 发送重置密码验证码
api.sendResetPasswordCode = (param) => axios.post(`api/v1.login/sendResetPasswordCode`, param)

// 注册
api.register = (param) => axios.post(`api/v1.login/register`, param)

// 登录
api.login = (param) => axios.post(`api/v1.login/login`, param)

// 登录2
api.login_e_p = (param) => axios.post(`api/v1.login/login_e_p`, param)

// 根据邮箱重置密码
api.resetPasswordByEmail = (param) => axios.post(`api/v1.login/resetPasswordByEmail`, param)

// 根据手机号重置密码
api.resetPasswordBymobile = (param) => axios.post(`api/v1.login/resetPasswordBymobile`, param)


// 获取用户信息
api.user_info = () => axios.post(`api/v1.user/user_info`)
// 协议管理
api.agreement = (param) => axios.post(`api/v1.index/agreement`, param)

// 查询对应科目
api.getMyPapersWithSubject = (param) => axios.post(`api/v1.order/getMyPapersWithSubject`, param)

// 查询科目详情以及对应的试卷
api.getMyPapersWithSubjectfind = (param) => axios.post(`api/v1.order/getMyPapersWithSubjectfind`, param)

// 查询科目下面的试卷列表
api.question_list = (param) => axios.post(`api/v1.order/question_list`, param)

// 发送短信验证码
api.send = (param) => axios.post(`api/v1.login/send`, param)

// 查询试卷详情
api.PaperInfo = (param) => axios.post(`api/v1.order/PaperInfo`, param)
// 模拟试卷
api.getQuestion = (param) => axios.post(`api/v1.question/getQuestion`, param)


api.getQuestionPart = (param) => axios.post(`api/v1.question/getQuestionPart`, param)



// 记录用户做题
api.recordQuestion = (param) => axios.post(`api/v1.question/recordQuestion`, param)



// 更新考试状态
api.updateExamStatus = (param) => axios.post(`api/v1.question/updateExamStatus`, param)



// 查询做卷的详情
api.get_question_exam = (param) => axios.post(`api/v1.question/get_question_exam`, param)

// 自动生成
api.autoGenerate = (param) => axios.post(`api/v1.order/autoGenerate`, param)

// 开始练习章节信息
api.getQuestionPaper = (param) => axios.post(`api/v1.question/getQuestionPaper`, param)


// 获取页数和查看记录
api.getQuestionLog = (param) => axios.post(`api/v1.question/getQuestionLog`, param)


// 收藏
api.addUserCollection = (param) => axios.post(`api/v1.user/addUserCollection`, param)

// 添加疑问
api.addQuestionCorrection = (param) => axios.post(`api/v1.user/addQuestionCorrection`, param)
// 查询订单下面的章信息
api.order_chapter = (param) => axios.post(`api/v1.order/order_chapter`, param)

// 章节练习完成信息
api.getQuestionPapercomplete = (param) => axios.post(`api/v1.question/getQuestionPapercomplete`, param)

// 清空章节做题记录
api.clear_exam_record = (param) => axios.post(`api/v1.question/clear_exam_record`, param)

// 证书列表
api.certificate_list = (param) => axios.post(`api/v1.index/certificate_list`, param)

// 年龄范围
api.age_list = (param) => axios.post(`api/v1.index/age_list`, param)

// 国家
api.country_list = (param) => axios.post(`api/v1.index/country_list`, param)


// 职业学生身份
api.professional_list = (param) => axios.post(`api/v1.index/professional_list`, param)

// 修改用户信息
api.user_edit = (param) => axios.post(`api/v1.user/user_edit`, param)

// 获取视频章节信息
api.order_chapter_class = (param) => axios.post(`api/v1.order/order_chapter_class`, param)
// 用户观看视频
api.addUserVideoRecord = (param) => axios.post(`api/v1.user/addUserVideoRecord`, param)

api.upload = (param) => axios.post(`api/v1.index/upload`, param)

// 多语言
api.dict_data = (param) => axios.post(`api/v1.index/dict_data`, param)


// 学习笔记
api.add_lecturer = (param) => axios.post(`api/v1.user/add_lecturer`, param)

// 添加课件
api.addCoursewareViewRecord = (param) => axios.post(`api/v1.user/addCoursewareViewRecord`, param)

// 系统参数    watermark=水印
api.config = (param) => axios.post(`api/v1.index/config`, param)


api.videoToStream = (param) => axios.post(`api/v1.index/videoToStream`, param)

// 首页的分类
api.category_list = (param) => axios.post(`api/v1.index/category_list`, param)
// 首页产品
api.product_list = (param) => axios.post(`api/v1.index/product_list`, param)

// 课程中心 筛选 证书列表
api.certificate_list = (param) => axios.post(`api/v1.index/certificate_list`, param)

// 课程中心 筛选 科目列表
api.subject_list = (param) => axios.post(`api/v1.index/subject_list`, param)

// 产品管理详情
api.product_detail = (param) => axios.post(`api/v1.index/product_detail`, param)
// 获取课程详情
api.course_detail = (param) => axios.post(`api/v1.index/course_detail`, param)
// 获取科目详情
api.subject_detail = (param) => axios.post(`api/v1.index/subject_detail`, param)

// 资讯分类
api.news_category = (param) => axios.post(`api/v1.index/news_category`, param)

// 资讯列表
api.news_news_list = (param) => axios.post(`api/v1.index/news_news_list`, param)

// 资讯详情
api.news_detail = (param) => axios.post(`api/v1.index/news_detail`, param)



// 资源分类
api.resource_classify = (param) => axios.post(`api/v1.index/resource_classify`, param)

// 资源下载列表
api.resource_download_list = (param) => axios.post(`api/v1.index/resource_download_list`, param)

// 资源下载详情
api.resource_download = (param) => axios.post(`api/v1.index/resource_download`, param)

// 1点赞,2=收藏
api.news_resource_like = (param) => axios.post(`api/v1.index/news_resource_like`, param)

// 咨询评价
api.news_comment = (param) => axios.post(`api/v1.index/news_comment`, param)

// 资源评价
api.resource_comment = (param) => axios.post(`api/v1.index/resource_comment`, param)
// 问答专区分类 
api.community_classify = (param) => axios.post(`api/v1.community/community_classify`, param)

// 问答专区下载列表
api.community_list = (param) => axios.post(`api/v1.community/community_list`, param)
// 问答专区详情
api.community_detail = (param) => axios.post(`api/v1.community/community_detail`, param)

// 图文管理
api.bannerList = (param) => axios.post(`api/v1.adszone/bannerList`, param)

// 收藏列表
api.myCollection = (param) => axios.post(`api/v1.index/myCollection`, param)
// 购物车列表
api.cart_list = (param) => axios.post(`api/v1.cart/getList`, param)
// 添加/编辑购物车
api.addOrEdit = (param) => axios.post(`api/v1.cart/addOrEdit`, param)

// 更新购物车选中状态
api.updateSelected = (param) => axios.post(`api/v1.cart/updateSelected`, param)

// 购物车删除
api.deleteBatch = (param) => axios.post(`api/v1.cart/deleteBatch`, param)



// 获取通知列表
api.getList = (param) => axios.post(`api/v1.notification/getList`, param) //type :1 系统 2其他
// 红点数量
api.getRedDot = (param) => axios.post(`api/v1.notification/getRedDot`, param)
// 一键已读
api.markAllRead = (param) => axios.post(`api/v1.notification/markAllRead`, param)

// 通知详情
api.getNoticeDetail = (param) => axios.post(`api/v1.notification/getDetail`, param)



// 订单列表
api.order_list = (param) => axios.post(`api/v1.order/order_list`, param)

// 取消未支付订单
api.cancelUnpaidOrder = (param) => axios.post(`api/v1.order/cancelUnpaidOrder`, param)

// 查询我的问答
api.my_questions = (param) => axios.post(`api/v1.community/my_questions`, param)

// 用户发起提问
api.create_question = (param) => axios.post(`api/v1.community/create_question`, param)

// 创建订单
api.create_order = (param) => axios.post(`api/v1.pay/create_order`, param)
// 支付选中的购物车商品（购物车创建订单）
api.paySelected = (param) => axios.post(`api/v1.pay/paySelected`, param)
// 根据订单号查询支付订单详情
api.getPayOrderByOrderNo = (param) => axios.post(`api/v1.pay/getPayOrderByOrderNo`, param)

// 选中的购物车商品
api.getSelectedItems = (param) => axios.post(`api/v1.cart/getSelectedItems`, param)

// 在我的订单里面 点击立即支付的时候 回重新返回一个新的支付pay_order_id  ,参数：order_id
api.createPayOrder = (param) => axios.post(`api/v1.pay/createPayOrder`, param)

// 计算订单金额金额接口
// pay_order_id=支付订单的id
// is_pay_money=是否余额抵扣  1是   2=否
// coupon=优惠码
// invitation_code=邀请码
api.calculateAmount = (param) => axios.post(`api/v1.pay/calculateAmount`, param)


// 发起支付
api.pay = (param) => axios.post(`api/v1.pay/pay`, param)
// 友情链接列表
api.linkList = (param) => axios.post(`api/v1.website/linkList`, param)

// 底部导航
api.navList = (param) => axios.post(`api/v1.website/navList`, param)


// 获取会话上下文
api.getContext = (param) => axios.post(`api/v1.prompt/getContext`, param)
// 保存聊天记录
api.saveHistory = (param) => axios.post(`api/v1.prompt/saveHistory`, param)

// 删除会话记录
api.deleteHistory = (param) => axios.post(`api/v1.prompt/deleteHistory`, param)


// 获取会话列表
api.getSessions = (param) => axios.post(`api/v1.prompt/getSessions`, param)




// 查询聊天记录
api.getHistory = (param) => axios.post(`api/v1.prompt/getHistory`, param)
// 查询聊天提示词
api.getPrompt = (param) => axios.post(`api/v1.prompt/getPrompt`, param)


// 余额明细
api.user_money_log = (param) => axios.post(`api/v1.user/user_money_log`, param)

// 提现
api.user_finance = (param) => axios.post(`api/v1.user/user_finance`, param)

// 申请发票
api.add_invoice = (param) => axios.post(`api/v1.order/add_invoice`, param)


// 邀请码列表
api.user_invitation_code_list = (param) => axios.post(`api/v1.user/user_invitation_code_list`, param)
// 申请邀请码
api.user_invitation_code = (param) => axios.post(`api/v1.user/user_invitation_code`, param)



// 用户日志记录
api.user_log = (param) => axios.post(`api/v1.user/user_log`, param)

// action=行为类型:question 查看题目
// type 类型:0=默认,1=自由组卷,2=模拟考,3章节练习,4=错题练习,5=收藏练习,6=试做
// course_question_id 题目ID
// title 日志标题



api.dict_data_cq = (param) => axios.post(`api/v1.index/dict_data_cq`, param)

api.logout = (param) => axios.post(`api/v1.login/logout`, param)


api.getSystemNotice = (param) => axios.post(`api/v1.notification/getSystemNotice`, param)

// 获取视频信息
api.getvideo_info = (param) => axios.post(`api/v1.order/video_info`, param)



api.updateSettings = (param) => axios.post(`api/v1.user/updateSettings`, param)

api.checkCoursePermission = (param) => axios.post(`api/v1.order/checkCoursePermission`, param)

export default api;